import { HardHat, PawPrint, Wrench } from 'lucide-react'

import { AutoLiabilityIcon } from '@/components/icons/AutoLiabilityIcon'
import { CargoIcon } from '@/components/icons/CargoIcon'
import { GeneralLiabilityIcon } from '@/components/icons/GeneralLiabilityIcon'
import { PhysicalDamageIcon } from '@/components/icons/PhysicalDamageIcon'
import { CoverageType } from '@/models/insuranceCoverage'

/** One icon per coverage, shared by the summary list and the change-coverages picker. */
export const COVERAGE_ICONS: Record<CoverageType, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  [CoverageType.AUTO_LIABILITY]: AutoLiabilityIcon,
  [CoverageType.AUTO_PHYSICAL_DAMAGE]: PhysicalDamageIcon,
  [CoverageType.GENERAL_LIABILITY]: GeneralLiabilityIcon,
  [CoverageType.MOTOR_TRUCK_CARGO]: CargoIcon,
  [CoverageType.WORKERS_COMPENSATION]: HardHat,
  [CoverageType.PET]: PawPrint,
  [CoverageType.TOOLS_AND_EQUIPMENT]: Wrench,
}
